/* eslint-disable @typescript-eslint/strict-boolean-expressions */
/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
const buttonBase = {
  defaultProps: {
    disableRipple: false,
  },
};

export default buttonBase;
